<template>
    <div>
        <b-col cols="12" class="mb-4">
            <PageTitle title="Aguardando produtos" />
        </b-col>
        <b-col cols="12" class="mb-4">
          <div>
            <b-button 
                class="mr-3" 
                variant="danger"
                @click="$refs.videoManual.toggleOpen({ 
                    url: 'https://www.youtube.com/watch?v=xljVAQoU8bk&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=1', 
                    title: 'Aguardando produtos' 
                })"
            >
                <i class="fas fa-play mr-1"></i>
                Ver video
            </b-button>
              <a class="btn btn-success" href="https://api.construp.com.br/assets/Aguardando produto.pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
          </div>
        </b-col>
        
        <b-col cols="12" class="mb-4">
          <PeriodsFilters
            ref="periodsFilters"
            :setDatesAutomatic="false"
            :startDate.sync="startDate"
            :endDate.sync="endDate"
            @click.native="get()"
          />
        </b-col>

        <b-col cols="12" class="mb-4">
            <h3>Encontrado {{ pagination.total }} solicitações</h3>
        </b-col>
        <b-col>
          <b-table
            striped
            hover
            responsive
            :fields="table.headers"
            :items="table.records"
            :busy="loading"
          >
            <template #table-busy>
            <div class="text-center my-2">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Carregando...</strong>
            </div>
            </template>

            <template #cell(photos)="data">
                <img 
                    :src="formatImg(data.item.photos[0].foto_png)" 
                    :alt="data.item.productName" 
                    class="formatImg"
                >
            </template>

            <template #cell(whatsapp)="data">
                {{formatPhone(data.item.whatsapp) }}
            </template>

            <template #cell(action)="data">
                <b-button
                  variant="outline-dark"
                  size="sm"
                  title="Detalhes"
                  class="mr-2 mb-2"
                  @click="$refs.waitingProductDetails.toggleOpen({ data: data.item })"
            >
              <i class="fas fa-eye"></i>
            </b-button>
            </template>

          </b-table>
        </b-col>
        <b-col cols="12" class="d-flex align-items-center justify-content-center">
            <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.total"
                :per-page="pagination.itemsPerPage"
                :disabled="loading"
            ></b-pagination>
        </b-col>
        <VideoManual ref="videoManual"/>
        <WaitingProductDetails ref="waitingProductDetails"/>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PageTitle from '../../../components/PageTitle.vue';
import makeToast from '../../../mixins/makeToast';
import PeriodsFilters from '@/components/Inputs/PeriodsFilters.vue';
import VideoManual from '@/components/VideoManual.vue';
import WaitingProductDetails from '@/components/WaitingProductDetails.vue';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';

export default {
    name: 'WaitingProduct',
    mixins: [makeToast],
    components: { 
      PageTitle, 
      PeriodsFilters,
      VideoManual,
      WaitingProductDetails
    },

    watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },

data() {
    return {
        loading: false,
        pagination: {
            currentPage: 1,
            itemsPerPage: 20,
            total: 0,
        },
        startDate: '',
        endDate: '',
        table: {
          headers: [
          {
            key: 'productId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'photos',
            label: 'Foto',
            sortable: false,
          },
          {
            key: 'codbar',
            label: 'Codigo de barras',
            sortable: false,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell"           },
          {
            key: 'productName',
            label: 'Produto',
            sortable: false,
          },
          {
            key: 'brand',
            label: 'Marca',
            sortable: false,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: 'client',
            label: 'Cliente',
            sortable: false,
          },
          {
            key: 'email',
            label: 'Email',
            sortable: false,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: 'whatsapp',
            label: 'Whatsapp',
            sortable: false,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: 'dateRequestClient',
            label: 'Data solicitação',
            sortable: false,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: 'action',
            label: 'Detalhes',
            sortable: false,
            tdClass: "d-md-none " ,
            thClass: "d-md-none "
          },
        ],
        records: [],
      },
    }
},

computed: {
    ...mapState(['dadosUsuario']),
},

mounted() {
    this.get();
},

methods: {
    ...mapActions('shopkeeper', ['getProductUnavailable']),

    get(){
        this.limpar = false;
        this.loading = true,
        this.$store.dispatch('startLoader');
        
        this.getProductUnavailable({
            userId: this.userTypeId(),
            currentPage: this.pagination.currentPage,
            startDate: this.startDate || '' ,
            endDate: this.endDate || ''
        })
          .then((response) => {
              this.pagination.total = response.data.data.total || 0;
              this.pagination.currentPage = response.data.data.currentPage;
              this.pagination.itemsPerPage = response.data.data.perPage || 20;
              this.table.records = response.data.data.data;
          })
          .finally(() => {
              this.loading = false;
              this.$store.dispatch('endLoader');
          });
    },
    formatImg(img) {
        return process.env.VUE_APP_FOTOS_URL+img;
    },
    formatPhone(value) {
        if (!value) return ""
        value = value.replace(/\D/g,'')
        value = value.replace(/(\d{2})(\d)/,"($1) $2")
        value = value.replace(/(\d)(\d{4})$/,"$1-$2")
        return value
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission() {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name == NamePermission.CUSTOMIZACAO_EMPRESA
        );

        if (
          this.$route.meta.userType == UserTypes.BALCONISTA &&
          permission.type == TypePermission.BALCONISTA
        ) {
          return false;
        }
      }
      return true;
    },
  } 
}
</script>

<style scoped>
.formatImg {
  width: 80px;
}

</style>